import React, { Component } from "react";
import { styled } from "@mui/material/styles";
import { Link, withRouter } from "react-router-dom";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";
import { connect } from "react-redux";
import { Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const Root = styled("div")(({ sideBarOpen }) => ({  position: "absolute",
  top: 0,
  left: sideBarOpen ? 320 : 92,
  height: 64,
  display: "flex",
  alignItems: "center",
  paddingLeft: 2,
  gap: 7,
  overflowX: "auto",
  transition: "left 0.3s ease",
  
}));

const routes = [
  { path: "/", breadcrumb: () => <span>Home</span> },
  { path: "/my_studies", breadcrumb: () => <span>My Studies</span> },
  { path: "/my_studies/overview", breadcrumb: null },
  { path: "/my_studies/overview/:studyId", breadcrumb: () => <span>Overview</span> },
  { path: "/my_studies/overview/:id/reports", breadcrumb: () => <span>Reports</span> },
  {
    path: "/my_studies/overview/:studyId/study-specific-stims",
    breadcrumb: () => <span>Study Specific Stims</span>,
  },
  { path: "/my_studies/overview/:studyId/study/cell_id", breadcrumb: null },
  {
    path: "/my_studies/overview/:studyId/study/cell_id/:cell_id/step_id/:stepId",
    breadcrumb: null,
  },
  {
    path: "/my_studies/overview/:studyId/study/cell_id/:cell_id/step_id/:stepId/stim_id",
    breadcrumb: null,
  },
  {
    path: "/my_studies/overview/:studyId/study/cell_id/:cell_id/step_id/:stepId/stim_id/:stimId",
    breadcrumb: null,
  },
  {
    path: "/my_studies/overview/:studyId/study/cell_id/:cell_id/step_id/:stepId/stim_id/:stimId/kpi",
    breadcrumb: null,
  },
  { path: "/feature_analysis/:studyId/study/cell_id/:cellId/step_id/:stepId", breadcrumb: null },
  { path: "/attention_report", breadcrumb: () => <span>Attention Report</span> },
  { path: "/create-study/YouTube-study", breadcrumb: () => <span>YouTube Study</span> },
  { path: "/stims", breadcrumb: () => <span>Stims</span> },
  { path: "/stims/edit", breadcrumb: null },
  { path: "/stims/edit/:id", breadcrumb: () => <span>Edit Stim</span> },
  { path: "/stims/aoi/:id", breadcrumb: null },
  { path: "/batches/aoi/:id", breadcrumb: null },
  { path: "/batch_stim_list", breadcrumb: () => <span>Batch Stim List</span> },
  { path: "/batch_stim_list/aoi/:id", breadcrumb: null },
  { path: "/my_batches", breadcrumb: () => <span>My Batches</span> },
  { path: "/my_batches/batch_overview", breadcrumb: null },
  { path: "/my_batches/batch_overview/:id", breadcrumb: () => <span>Batch Overview</span> },
  {
    path: "/my_batches/batch_overview/:id/batch_report",
    breadcrumb: () => <span>Batch Report</span>,
  },
  { path: "/cell_id", breadcrumb: null },
  { path: "/step_id", breadcrumb: null },
  { path: "/overview", breadcrumb: () => <span>Overview</span> },
  {
  path: "/my_studies/overview/:studyId/cell_step_management",
  breadcrumb: () => <span>Cell Step Management</span>,
  },
  {
    path: "/my_studies/overview/:studyId/cell_step_management/:columnId",
    breadcrumb: null,
  },
  {
    path: "/my_studies/overview/:studyId/cell_step_management/:columnId/add-step",
    breadcrumb: null,
  },
  {
    path: "/my_studies/overview/:studyId/cell_step_management/:columnId/add-step/:category",
    breadcrumb: () => <span>Add Step</span>, 
    },
];

class Breadcrumbs extends Component {
  render() {
    const { breadcrumbs } = this.props;

    return (
<Root sideBarOpen={this.props.side_bar_open}>
{breadcrumbs.map(({ breadcrumb, match }, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <span key={match.url} style={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="h6"
                component="span"
                style={{ color: isLast ? "white" : "#89dcea" }}
              >
                <Link
                  to={match.url}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  {breadcrumb}
                </Link>
              </Typography>
              {!isLast && (
                <NavigateNextIcon
                  style={{ color: "#89dcea", margin: 4 }}
                  fontSize="small"
                />
              )}
            </span>
          );
        })}
      </Root>
    );
  }
}

const mapStateToProps = (state) => ({
  side_bar_open: state.homeReducer.side_bar_open,
});

export default withRouter(
  connect(mapStateToProps)(
    withBreadcrumbs(routes)(Breadcrumbs)
  )
);